module.exports = __webpack_public_path__ + "static/media/riseLogo.dd457c5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/riseLogo.svg
// module id = 1027
// module chunks = 0